import React from "react";
import {TextEditor} from "../fusion-ui";
import {TextEditorApiKey} from "../CommonConfig";

/**
 * Create a @tinymc based text-editor.
 *
 * It requires API-key which can be generated from here: {@link https://www.tiny.cloud/my-account/integrate/#react}
 *
 * Add new domains: {@link https://www.tiny.cloud/my-account/domains/}
 *
 * @example
 * const [editorText, setEditorText] = useState('Editor text');
 *    <AppTextEditor
 *         id={'editor'}
 *         label={'Text Editor'}
 *         height={300}
 *         initialValue={undefined}
 *         value={editorText}
 *         required={false}
 *         labelColor={'black'}
 *         onChange={(content) => {
 *             setEditorText(content);
 *         }}
 *  />
 */
const AppTextEditor = React.memo(({
                                      labelClassName = '',
                                      height = 300,
                                      value,
                                      id,
                                      initialValue,
                                      onChange,
                                      required,
                                      label = "",
                                      labelColor = '',
                                      labelStyle = {},
                                      ...rest
                                  }) => {
    const TAG = "TextEditor";
    return (
        <TextEditor
            labelClassName={labelClassName}
            apiKey={TextEditorApiKey}
            height={height}
            value={value}
            id={id}
            initialValue={initialValue}
            onChange={onChange}
            required={required}
            label={label}
            labelColor={labelColor}
            labelStyle={labelStyle}
            {...rest}
        />
    );
});

export default AppTextEditor;
